export const languages = ["nb-NO", "nn-NO", "en-US"];
